import { Attachment, Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Component } from './ComponentApi';
import { ProductTypeCategory } from './ProductTypeCategoryApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum MontageType {
	INSIDE = 'INSIDE',
	ON_WALL = 'ON_WALL',
	BOTH = 'BOTH',
}

export const availableRollerBoxHeights = [165, 205, 245] as const;
export const availableRollerBoxDepths = [175, 215, 255] as const;
export const availableRollerShaftDiameters = [40, 60] as const;

export type RollerBoxHeight = (typeof availableRollerBoxHeights)[number];
export type RollerBoxDepth = (typeof availableRollerBoxDepths)[number];
export type RollerShaftDiameter =
	(typeof availableRollerShaftDiameters)[number];

// HR - total height
// HW - window height

export interface ShaftDiameterConfig {
	maxHr: number;
	maxHw: number;
}

export type RollerShaftDiameterConfig = Record<
	RollerShaftDiameter,
	ShaftDiameterConfig
>;

export interface ProductTypeRollerBoxHeightConfig {
	rollerBoxHeight: RollerBoxHeight;
	rollerBoxDepth: RollerBoxDepth;
	withMosquitoNet: boolean;
	additionalAttributeValues: UUID[];
	attributeValuesConfig: Record<UUID, RollerShaftDiameterConfig>;
}

export interface ProductType extends BaseEntity {
	name: string;
	description: string;
	code: string;
	components: Component[];
	montageType: MontageType;
	category: ProductTypeCategory;
	image: Attachment | null;
	rollerBoxHeightConfigs: ProductTypeRollerBoxHeightConfig[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductTypeApi extends EntityApi<ProductType> {
	constructor() {
		super(ApiQueryKey.productTypes);
	}
}

export default new ProductTypeApi();
